/* eslint-disable */
import { defineStore } from 'pinia';
import { useStorage } from '@vueuse/core';

export const useContextStore = defineStore('context', {
  state: () => ({
    latestContextIdData: useStorage('piniaLatestContextId', ''),
    contextData: useStorage('piniaContext', ''),
    organizationData: useStorage<any>('piniaOrganization', {} as any)
  }),
  getters: {
    latestContextId: (state) => {
      return state.latestContextIdData ? state.latestContextIdData : null;
    },
    contextId: (state) => {
      return !!state.contextData ? state.contextData : null;
    },
    organization: (state) => {
      return !!state.organizationData?.id ? state.organizationData : null;
    }
  },
  actions: {
    updateContext(contextId: string) {
      this.latestContextIdData = contextId;
      this.contextData = contextId;
    },
    updateOrganization(organization: any) {
      this.organizationData = organization;
    }
  }
});
